import {
  Button,
  Message,
  MessageTheme,
  Modal
} from '@platform/ui-library';
import {
  FC,
  useCallback
} from 'react';
import { useServices, useSubject } from '@app/hooks';
import { ErrorMessageType } from '@app/services';
import style from './style/ErrorMessageModal.module.scss';

/** Displays errors stored in @see ErrorMessageService in a modal. */
export const ErrorMessageModal: FC = () => {
  const { errorMessageService } = useServices();
  const topError = useSubject(
    errorMessageService.topErrorChange,
    errorMessageService.topError
  );

  const {
    message,
    onClose,
    title = 'An Unhandled Error Occurred',
    type = ErrorMessageType.error
  } = topError ?? {};

  const handleClose = useCallback(() => {
    errorMessageService.popError();
    onClose?.();
  }, [errorMessageService, onClose]);

  const bannerTheme = (type === ErrorMessageType.warning) ? (
    MessageTheme.warning
  ) : MessageTheme.error;

  const messageContent = (
    <>
      <h2>{title}</h2>
      <div className={style.message}>{message ?? 'An unknown error occurred.'}</div>
      <div className={style.actions}>
        <Button color="error" onClick={handleClose} theme={['color']}>
          {window.l.popup.close}
        </Button>
      </div>
    </>
  );

  // Do not use `isOpen` so we can guarantee this modal being on top.
  return (!topError) ? null : (
    <Modal handleClose={handleClose} isOpen>
      <Message
        className={style.content}
        dismissible
        message={messageContent}
        onDismiss={handleClose}
        theme={bannerTheme}
        variant="banner"
      />
    </Modal>
  );
};
